module.exports = __webpack_public_path__ + "img/pagamento.9f589020.png";